import React, { useEffect, useState } from 'react'
import Layout from '../Layout/Layout'
import { useDispatch, useSelector } from 'react-redux'
import { FETCH_CATEGORIES, UPDATE_CATEGORY } from 'src/redux/categoriesReducer'
import { useParams } from 'react-router-dom'
import { RootReducer } from 'src/redux/rootReducer'

const TIER_FIELDS = [
  { key: 'to_50', label: 'bis 50 km' },
  { key: 'to_100', label: 'bis 100 km' },
  { key: 'to_200', label: 'bis 200 km' },
  { key: 'to_400', label: 'bis 400 km' },
  { key: 'to_600', label: 'bis 600 km' },
  { key: 'to_800', label: 'bis 800 km' },
  { key: 'to_1000', label: 'bis 1000 km' }
] as const

type TierKey = (typeof TIER_FIELDS)[number]['key']

const emptyTiers: Record<TierKey, string> = {
  to_50: '',
  to_100: '',
  to_200: '',
  to_400: '',
  to_600: '',
  to_800: '',
  to_1000: ''
}

const CategoryFormScreen = (): JSX.Element => {
  const { id } = useParams()
  const dispatch = useDispatch()
  const reducerCategory = useSelector((state: RootReducer) => {
    return state.categoriesReducer.categories.find((category) => category.id === Number(id)) ?? null
  })
  const [tiers, setTiers] = useState<Record<TierKey, string>>(emptyTiers)

  useEffect(() => {
    dispatch(FETCH_CATEGORIES())
  }, [dispatch])

  useEffect(() => {
    if (reducerCategory !== null) {
      setTiers({
        to_50: reducerCategory.to_50 === null ? '' : String(reducerCategory.to_50),
        to_100: reducerCategory.to_100 === null ? '' : String(reducerCategory.to_100),
        to_200: reducerCategory.to_200 === null ? '' : String(reducerCategory.to_200),
        to_400: reducerCategory.to_400 === null ? '' : String(reducerCategory.to_400),
        to_600: reducerCategory.to_600 === null ? '' : String(reducerCategory.to_600),
        to_800: reducerCategory.to_800 === null ? '' : String(reducerCategory.to_800),
        to_1000: reducerCategory.to_1000 === null ? '' : String(reducerCategory.to_1000)
      })
    }
  }, [reducerCategory])

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>): void => {
    e.preventDefault()

    const hasEmpty = TIER_FIELDS.some(({ key }) => tiers[key].trim() === '')
    if (hasEmpty) {
      return
    }
    dispatch(
      UPDATE_CATEGORY({
        id: Number(id),
        to_50: Number(tiers.to_50),
        to_100: Number(tiers.to_100),
        to_200: Number(tiers.to_200),
        to_400: Number(tiers.to_400),
        to_600: Number(tiers.to_600),
        to_800: Number(tiers.to_800),
        to_1000: Number(tiers.to_1000)
      })
    )
  }

  return (
    <Layout>
      <div className="font-semibold text-16 p-3">
        {reducerCategory !== null && (
          <p className="mb-4 text-primary text-sm">
            Kategorie: <span className="font-bold">{reducerCategory.name}</span>
          </p>
        )}
        <form onSubmit={handleSubmit}>
          {TIER_FIELDS.map(({ key, label }) => (
            <div className="mb-4" key={key}>
              <label className="block text-primary text-xs font-bold mb-2" htmlFor={key}>
                {label}
              </label>
              <input
                className="shadow appearance-none border rounded w-full py-2 px-3 text-primary text-xs leading-tight focus:outline-none focus:shadow-outline"
                id={key}
                type="number"
                step="any"
                value={tiers[key]}
                onChange={(e) => {
                  setTiers((prev) => ({ ...prev, [key]: e.target.value }))
                }}
              />
            </div>
          ))}
          <div className="flex items-center justify-between">
            <button
              className="bg-orange hover:bg-accent-dark text-white font-bold text-xs py-2 px-4 rounded focus:outline-none focus:shadow-outline"
              type="submit">
              Aktualisieren
            </button>
          </div>
        </form>
      </div>
    </Layout>
  )
}

export default CategoryFormScreen
